// Constants
import { API_ERROR_CODE, OPERATION_STATUS } from "./axios.init";

// Strings
import { Strings } from "../Translations/i18n";

const defaultErrorInfo = {
  code: API_ERROR_CODE.SERVER_ERROR,
  message: Strings("SorryAnErrorHasOccurred"),
  title: Strings("Error"),
};

export function getErrorInfo(errorCode) {
  let errorInfo = {};
  errorInfo.code = errorCode;

  switch (errorCode) {
    case OPERATION_STATUS.NETWORK_NOT_REACHABLE:
      errorInfo.message = Strings("NetworkNotReachable");
      errorInfo.title = Strings("ConnectionError");
      break;

    default:
      errorInfo = defaultErrorInfo;
  }

  return errorInfo;
}

// Error look-up function for error returned from APIs
export function getAPIErrorInfo(errorDetails) {
  console.log("errorDetails: ", errorDetails);
  let errorInfo = {};
  errorInfo.code = errorDetails.code;

  switch (errorDetails.code) {
    case API_ERROR_CODE.UNAUTHORIZED:
      errorInfo.message = Strings("UnauthorizedUser");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.INVALID_LOGIN_CREDENTIALS:
    case API_ERROR_CODE.BAD_REQUEST:
      errorInfo.message = Strings("InvalidLoginCredentials");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.DOCUMENT_NOT_FOUND:
      errorInfo.message = Strings("NoDocsForProcessing");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.SCHEDULED_PROCESS_FAILED:
      errorInfo.message = Strings("ScheduledProcessFailed");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.ERROR_IN_FILE:
      errorInfo.message = Strings("ErrorInFile");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.DUPLICATE_USER:
      errorInfo.message = Strings("DuplicateUserName");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.USER_NOT_FOUND:
      errorInfo.message = Strings("UserNotFound");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.USER_ALREADY_EXISTS:
      errorInfo.message = Strings("UserAlreadyExists");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.XML_PARSING_ERROR:
    case API_ERROR_CODE.ENCRYPTION_DECRYPTION_ERROR:
      errorInfo.message = Strings("InvalidXML");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.VALIDATION_ERROR:
      errorInfo.message = Strings("ValidationError");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.FORBIDDEN:
      errorInfo.message = Strings("Forbidden");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.INVALID_OLD_PASSWORD:
      errorInfo.message = Strings("InvalidOldPassword");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.USER_INACTIVE:
      errorInfo.message = Strings("UserNotActive");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.USERNAME_ALREADY_EXIST:
      errorInfo.message = Strings("UsernameAlreadyExists");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.ROLE_NOT_FOUND:
      errorInfo.message = Strings("RoleNotFound");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.FAILED_TO_SEND_EMAIL:
      errorInfo.message = Strings("FailedToSendEmail");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.ACCESS_NOT_FOUND:
      errorInfo.message = Strings("AccessNotFound");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.BINDING_RESULT:
      errorInfo.message = Strings("InvalidRequestParameters");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.SEARCH_PARAMETERS_CANT_BE_NULL:
      errorInfo.message = Strings("SearchParametersCanNotBeAllNull");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.LOAN_APP_NOT_FOUND:
      errorInfo.message = Strings("LoanApplicationNotFound");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.LOAN_APP_NOT_CREATED:
      errorInfo.message = Strings("LoanApplicationNotCreated");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.LOAN_APP_INCOMPLETE:
      errorInfo.message = Strings("LoanApplicationIncomplete");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.LOAN_APP_REJECTED:
      errorInfo.message = Strings("LoanApplicationRejected");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.LOAN_UPDATE_NOT_ALLOWED:
      errorInfo.message = Strings("LoanUpdateNotAllowed");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.LOAN_STATUS_UPDATE_NOT_ALLOWED:
      errorInfo.message = Strings("LoanStatusUpdateNotAllowed");
      errorInfo.title = Strings("SearchParametersCanNotBeAllNull");
      break;

    case API_ERROR_CODE.LOAN_OTP_CREATE_FAILED:
      errorInfo.message = Strings("OTPGenerationFailed");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.LOAN_OTP_NOT_FOUND:
      errorInfo.message = Strings("LoanOTPNotFound");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.LOAN_ANALYSIS_NOT_FOUND:
      errorInfo.message = Strings("AnalysisDataNotFound");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.LOAN_OTP_NOT_CREATE_ALLOWED:
      errorInfo.message = Strings("LoanOTPCreateNotAllowed");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.INSUFFICIENT_LOAN_APPLICATION_DATA:
      errorInfo.message = Strings("InsuffiecientLoanApplicationData");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.LOAN_APP_INVALID_STATUS:
      errorInfo.message = Strings("LoanAppInvalidStatus");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.DOCUMENT_ALREADY_UPLOADED:
      errorInfo.message = Strings("DocumentAlreadyUploaded");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.INSUFFICIENT_DOCUMENTS:
      errorInfo.message = Strings("InsufficientDocuments");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.DOCUMENT_DELETE_NOT_ALLOWED:
      errorInfo.message = Strings("DocumentDeleteNotAllowed");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.INVALID_CONFIGURATION_FORMAT:
      errorInfo.message = Strings("ErrorInvalidConfiguration");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.VERSION_ALREADY_EXIST:
      errorInfo.message = Strings("ErrorVersionExists");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.DRAFTED_CONFIGURATION_ALREADY_EXISTS:
      errorInfo.message = Strings("ErrorDraftedConfigurationExists");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.NO_CONFIGURATION_FOUND:
      errorInfo.message = Strings("ErrorConfigurationNotFound");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.NOT_ALLOWED_TO_UPDATE_CONFIGURATION:
      errorInfo.message = Strings("ErrorCannotUpdateConfig");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.NO_DRAFTED_CONFIGURATION_FOUND:
      errorInfo.message = Strings("ErrorDraftedConfigNotFound");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.NO_ACTIVE_CONFIGURATION_FOUND:
      errorInfo.message = Strings("ErrorActiveNotFound");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.BRANCH_NOT_FOUND:
      errorInfo.message = Strings("ErrorBranchNotFound");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.BRANCHS_NOT_DEFINED:
      errorInfo.message = Strings("ErrorBranchNotDefined");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.BRANCH_ALREADY_EXIST:
      errorInfo.message = Strings("ErrorBranchAlreadyExists");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.DEPOSIT_NOT_ALLOWED:
      errorInfo.message = Strings("ErrorDepositNotAllowed");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.LOAN_NOT_FOUND:
      errorInfo.message = Strings("LoanNotFound");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INVALID_NEGOTIATION_REQUEST:
      errorInfo.message = Strings("InvalidNegotiationRequest");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.NEGOTIATION_NOT_FOUND:
      errorInfo.message = Strings("NegotiationNotFound");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INVALID_NEGOTIATION_AMOUNT:
      errorInfo.message = Strings("InvalidNegotiationAmount");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INVALID_NEGOTIATION_RESPONSE:
      errorInfo.message = Strings("InvalidNegotiationResponse");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INVALID_NEGOTIATION_STATE:
      errorInfo.message = Strings("InvalidNegotiationState");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INVALID_NEGOTIATION_LATE_FEES:
      errorInfo.message = Strings("InvalidNegotiationLateFees");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INVALID_NEGOTIATION_INTEREST:
      errorInfo.message = Strings("InvalidNegotiationInterest");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.NO_RECORDS_FOUND:
      errorInfo.message = Strings("NoRecordsFound");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.LOW_CREDIT_SCORE_APP_REJECTED:
      errorInfo.message = Strings("appRejectedBecauseOfLowCreditScore");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.OPERATIONS_OFFICER_APPROVAL_FAILED:
      errorInfo.message = Strings("failedApprovalOfOperationsOfficer");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.LOAN_APPILCATION_SIGNATURE_NOT_FOUND:
      errorInfo.message = Strings("SignatureNotFound");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INSUFFICIENT_CREDIT_LIMIT:
      errorInfo.message = Strings("InsufficientCreditLimit");
      errorInfo.title = Strings("Error");
      errorInfo.data = errorDetails.message;
      break;
    case API_ERROR_CODE.PRODUCT_CATEGORY_ALREADY_EXISTS:
      errorInfo.message = Strings("CategoryAlreadyExists");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.PRODUCT_ALREADY_EXISTS:
      errorInfo.message = Strings("ProductAlreadyExists");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INVALID_BRANCH_COUNT:
      errorInfo.message = Strings("InvalidBranchCount");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.USER_DEACTIVATION_FAILED:
      errorInfo.message = Strings("UserDeactivationFailed");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.NO_ADJACENT_USER_FOUND:
      errorInfo.message = Strings("NoAdjacentUserFound");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INVALID_USER_DEACTIVATION_REQUEST:
      errorInfo.message = Strings("InvalidUserDeactivationRequest");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.LOAN_REJECTED_DUE_TO_LOW_GRADE:
      errorInfo.message = Strings("LoanRejectedDuetoLowGrade");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.LOAN_REJECTED_DUE_TO_NEGATIVE_REFERENCES:
      errorInfo.message = Strings("LoanRejectedDueToNegativeReferences");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.CANNOT_CHANGE_ASSIGNMENT:
      errorInfo.message = Strings("CannotChangeAssignments");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.SAME_DATE_LOAN_CANCEL_FAIL:
      errorInfo.message = Strings("CannotCloseSameDateLoan");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.ACCOUNT_LOCKED_ERROR:
      errorInfo.message = Strings("ACCOUNT_LOCKED_ERROR_MESSAGE");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.NEGOTIATION_EXPIRED:
      errorInfo.message = Strings("NEGOTIATION_EXPIRED_MESSAGE");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.NEGOTIATION_EMPTY_FIELD_ERROR:
      errorInfo.message = Strings("EmptyFieldsError");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.SALESPERSON_ALREADY_ASSIGNED:
      errorInfo.message = Strings("SALESPERSON_ALREADY_ASSIGNED");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.PERMANENT_ASSIGNMENT_NOT_FOUND:
      errorInfo.message = Strings("PERMANENT_ASSIGNMENT_NOT_FOUND");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.SALESPERSONS_VISIT_IS_ALREADY_PLANNED:
      errorInfo.message = Strings("SALESPERSONS_VISIT_IS_ALREADY_PLANNED");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.HOLIDAY_ERROR:
      errorInfo.message = Strings("HOLIDAY_ERROR");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.HOLIDAY_ASSIGNMENT_ERROR:
      errorInfo.message = Strings("HOLIDAY_ASSIGNMENT_ERROR");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INTERNAL_SERVER_ERROR:
      errorInfo.message = Strings("INTERNAL_SERVER_ERROR");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.REMITTANCE_TIMEOUT:
      errorInfo.message = Strings("REMITTANCE_TIMEOUT_ERROR");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.SALESPERSON_POSITION_NOT_FILLED_ROUTE:
      errorInfo.message = Strings("salesPersonPositionNotFilledRoute");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INVALID_LATE_FEES_REQUEST:
      errorInfo.message = Strings("invalidLateFeesRequest");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INVALID_AMOUNT:
      errorInfo.message = Strings("INVALID_AMOUNT");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.POSITION_NOT_FOUND:
      errorInfo.message = Strings("POSITION_NOT_FOUND");
      break;
    case API_ERROR_CODE.POSITION_NAME_ALREADY_PRESENT:
      errorInfo.message = Strings("POSITION_NAME_ALREADY_PRESENT");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.BRANCH_ZONE_MAPPING_NOT_FOUND:
      errorInfo.message = Strings("BRANCH_ZONE_MAPPING_NOT_FOUND");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.ROUTE_NOT_FOUND:
      errorInfo.message = Strings("ROUTE_NOT_FOUND");
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.NO_MESSENGER_FOUND_FOR_NEW_POSITION:
      errorInfo.message = Strings(
        "NO_MESSENGER_FOUND_FOR_NEW_MESSENGER_POSITION"
      );
      errorInfo.title = Strings("Error");
      break;

    case API_ERROR_CODE.NO_MESSENGER_FOUND_IN_THE_ZONE:
      errorInfo.message = Strings("NO_MESSENGER_FOUND_IN_THE_ZONE");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INVALID_CREDIT_LIMIT_AMOUNT:
      errorInfo.message = Strings("INVALID_CREDIT_LIMIT_AMOUNT");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.MESSENGER_POSITION_NOT_FILLED_FOR_ROUTE:
      errorInfo.message = Strings("MESSENGER_POSITION_NOT_FILLED_FOR_ROUTE");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.NOTE_NOT_FOUND:
      errorInfo.message = Strings("NOTE_NOT_FOUND");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.REQUEST_NOT_FOUND:
      errorInfo.message = Strings("REQUEST_NOT_FOUND");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.MINIMART_NOT_FOUND:
      errorInfo.message = Strings("MINIMART_NOT_FOUND");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.REMITTANCE_CORE_CONNECTION_PROBLEM:
      errorInfo.message = errorDetails.message;
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INVALID_AMOUNT_ON_PROMOTION:
      errorInfo.message = Strings("INVALID_AMOUNT_ON_PROMOTION");
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.MULTIPLE_ACTIVE_LOANS:
      let lid = errorDetails.message.substring(
        errorDetails.message.indexOf("[") + 1,
        errorDetails.message.indexOf("]")
      );
      errorInfo.message = Strings("MULTIPLE_ACTIVE_LOANS").replace("$", lid);
      errorInfo.title = Strings("Error");
      break;
    case API_ERROR_CODE.INVALID_LOAN_COMBINATION:
      let loanType = errorDetails.message.substring(
        19,
        errorDetails.message.indexOf(" is")
      );
      let lids = errorDetails.message.substring(
        errorDetails.message.indexOf("[") + 1,
        errorDetails.message.indexOf("]")
      );
      const loanTypeList = errorDetails.message.substring(
        errorDetails.message.indexOf(
          "[",
          errorDetails.message.indexOf("[") + 1
        ) + 1,
        errorDetails.message.length - 1
      );
      let loan = "";
      loanTypeList
        .split(",")
        .forEach((type) => (loan = loan + Strings(type.trim()) + ", "));
      errorInfo.message = Strings("INVALID_LOAN_COMBINATION")
        .replace("$", Strings(loanType))
        .replace("#", lids)
        .replace("^", loan);
      errorInfo.title = Strings("Error");
      break;
    default:
      errorInfo = defaultErrorInfo;
  }

  return errorInfo;
}
